<template>
  <page class="referrals" :loading="!referrals">
    <b-row class="title" align-v="center">
      <b-col cols="12" sm="9">
        <h2>{{ $t('referrals.your-referrals-title') }}</h2>
      </b-col>
      <!-- b-col class="text-right" cols="12" sm="3" v-if="!isRecruiter && referrals && referrals.requested && canSyncContacts">
        <b-btn :to="{ name: 'ReferralRequests' }" variant="outline-primary">{{ $tc('referrals.ctas.referral-requests', referrals.requested.total) }}</b-btn>
      </b-col -->
    </b-row>

    <!-- Referrals & Referral Requests -->
    <!-- b-row class="lanes">
      <b-col cols="12" class="lane quadruple">

        <b-card body-class="d-flex flex-row justify-content-between">
          <h3>{{ $t('referrals.lanes.referrals-title') }}</h3>
          <div class="counter-icon bg-primary-a2 text-primary" v-if="referrals && referrals.accepted">
            <span class="label">{{referrals.accepted.total}}</span>
          </div>
        </b-card>

        <b-row v-if="referrals && referrals.accepted && Array.isArray(referrals.accepted.edges) && referrals.accepted.total" class="card-deck" data-tour="referrals-list">
          <b-col v-for="{ entry } in (showAllReferrals ? referrals.accepted.edges : referrals.accepted.edges.slice(0, 4))"
            :key="entry.id" cols="12" sm="3" class="card-col mt-2">
              <referral-lane-item class="h-100 mx-0" :referral="entry"/>
          </b-col>
          <b-col v-if="referrals.accepted.total > 4" cols="12" class="d-flex justify-content-center align-items-center w-100">
            <a class="my-2" href="#" @click.prevent="showAllReferrals = !showAllReferrals">{{ showAllReferrals ? 'Hide all' : 'Show all' }}</a>
          </b-col>
        </b-row>
        <b-card v-else class="no-results">
          <div class="round-icon bg-light"><font-awesome-icon icon="link" class="text-secondary-a5" /></div>
          <p>{{ $t('referrals.lanes.referrals-no-results') }}</p>
        </b-card>

      </b-col>
    </b-row -->

    <!-- Applications & Interviews & Hires & Rejections -->
    <b-row>

      <!-- Applications-->
      <b-col cols="12" lg="3" class="lane single mt-3 mt-lg-0" v-if="referrals && referrals.inProgress">
        <b-card body-class="d-flex flex-row justify-content-between" data-tour="your-applications">
          <h3>{{ $t('referrals.lanes.applications-title') }}</h3>
          <div class="counter-icon bg-primary-a2 text-primary">
            <span class="label">{{referrals.inProgress.total}}</span>
          </div>
        </b-card>

        <b-row v-if="referrals && referrals.inProgress && referrals.inProgress.total">
          <b-col v-for="{ entry } in referrals.inProgress.edges" :key="entry.id" cols="12" sm="12" class="card-col mt-2">
            <application-lane-item :ref="`application-lane-item-${entry.id}`" :application="entry" />
          </b-col>
        </b-row>
        <b-card v-else class="no-results mt-2">
          <div class="round-icon bg-light">
            <font-awesome-icon icon="file-alt" class="text-secondary-a5" />
          </div>
          <p>{{ $t('referrals.lanes.applications-no-results') }}</p>
        </b-card>
      </b-col>

      <!-- Applications-->
      <b-col cols="12" lg="12" class="lane single mt-3 mt-lg-0" v-if="referrals && referrals.allApplications">
        <b-card body-class="d-flex flex-row justify-content-between" data-tour="your-applications">
          <h3>{{ $t('referrals.lanes.applications-title') }}</h3>
          <div class="counter-icon bg-primary-a2 text-primary">
            <span class="label">{{referrals.allApplications.total}}</span>
          </div>
        </b-card>

        <b-row v-if="referrals && referrals.allApplications && referrals.allApplications.total">
          <b-col v-for="{ entry } in referrals.allApplications.edges" :key="entry.id" cols="12" sm="12" class="card-col mt-2">
            <application-lane-item :ref="`application-lane-item-${entry.id}`" :application="entry" />
          </b-col>
        </b-row>
        <b-card v-else class="no-results mt-2">
          <div class="round-icon bg-light">
            <font-awesome-icon icon="file-alt" class="text-secondary-a5" />
          </div>
          <p>{{ $t('referrals.lanes.applications-no-results') }}</p>
        </b-card>
      </b-col>

      <!-- Interviews -->
      <b-col cols="12" lg="3" class="lane single mt-3 mt-lg-0" v-if="referrals && referrals.interviewed">
        <b-card body-class="d-flex flex-row justify-content-between">
          <h3>{{ $t('referrals.lanes.interviewed-title') }}</h3>
          <div class="counter-icon bg-primary-a2 text-primary">
            <span class="label">{{referrals.interviewed.total}}</span>
          </div>
        </b-card>

        <b-row v-if="referrals && referrals.interviewed && referrals.interviewed.total">
          <b-col v-for="{ entry } in referrals.interviewed.edges" :key="entry.id" cols="12" sm="12" class="card-col mt-2">
            <application-lane-item :application="entry" />
          </b-col>
        </b-row>
        <b-card v-else class="no-results mt-2">
          <div class="round-icon bg-light">
            <font-awesome-icon icon="comments" class="text-secondary-a5" />
          </div>
          <p>{{ $t('referrals.lanes.interviewed-no-results') }}</p>
        </b-card>
      </b-col>

      <!-- Hires -->
      <b-col cols="12" lg="3" class="lane single mt-3 mt-lg-0" v-if="referrals && referrals.hired && !referrals.allApplications">
        <b-card body-class="d-flex flex-row justify-content-between">
          <h3>{{ $t('referrals.lanes.hired-title') }}</h3>
          <div class="counter-icon bg-primary-a2 text-primary">
            <span class="label">{{referrals.hired.total}}</span>
          </div>
        </b-card>

        <b-row v-if="referrals && referrals.hired && referrals.hired.total">
          <b-col v-for="{ entry } in referrals.hired.edges" :key="entry.id" cols="12" sm="12" class="card-col mt-2">
            <application-lane-item :application="entry" />
          </b-col>
        </b-row>
        <b-card v-else class="no-results mt-2">
          <div class="round-icon bg-light">
            <font-awesome-icon icon="handshake" class="text-secondary-a5" />
          </div>
          <p>{{ $t('referrals.lanes.hired-no-results') }}</p>
        </b-card>
      </b-col>

      <!-- Rejections -->
      <b-col cols="12" lg="3" class="lane single mt-3 mt-lg-0"  v-if="referrals && referrals.rejected">
        <b-card body-class="d-flex flex-row justify-content-between">
          <h3>{{ $t('referrals.lanes.rejected-title') }}</h3>
          <div class="counter-icon bg-primary-a2 text-primary">
            <span class="label">{{referrals.rejected.total}}</span>
          </div>
        </b-card>

        <b-row v-if="referrals && referrals.rejected && referrals.rejected.total">
          <b-col v-for="{ entry } in referrals.rejected.edges" :key="entry.id" cols="12" sm="12" class="card-col mt-2">
            <application-lane-item :application="entry" />
          </b-col>
        </b-row>
        <b-card v-else class="no-results mt-2">
          <div class="round-icon bg-light">
            <font-awesome-icon icon="ban" class="text-secondary-a5" />
          </div>
          <p>{{ $t('referrals.lanes.rejected-no-results') }}</p>
        </b-card>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';
import ApplicationLaneItem from '@/components/job-applications/lane-item';
import ReferralLaneItem from '@/components/job-referrals/lane-item';
import ReferralsEmployeeQuery from '@/graphql/queries/ReferralsEmployee.gql';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
    ReferralLaneItem,
    ApplicationLaneItem,
  },
  data: () => ({
    err: null,
    showAllReferrals: false
  }),
  apollo: {
    referrals: {
      query: ReferralsEmployeeQuery,
      variables() {
        const { showApplicationProgress } = this;
        return { showApplicationProgress, hideApplicationProgress: !showApplicationProgress };
      },
      update(data) {
        const { user } = data;
        const { requested, accepted, inProgress, hired, interviewed, rejected, allApplications } = user;
        return { requested, accepted, inProgress, hired, interviewed, rejected, allApplications };
      },
      result({ loading, data }) {
        // auto open and fill modal if redirected from email
        if (!loading && data && data.user) {
          if (this.$route.query && this.$route.query.applicationID && this.$route.query.answer) {
            const { applicationID, answer } = this.$route.query;
            setTimeout(() => {
              const applicationLaneItem = this.$refs[`application-lane-item-${applicationID}`];
              if (applicationLaneItem && applicationLaneItem[0]) {
                this.$bvModal.show(`application-supporting-questions-${applicationID}`);
                const modal = applicationLaneItem[0].$refs[`application-supporting-questions-${applicationID}`];
                modal.answers.type = answer;
              }
            }, 500);
          }
        }
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  },
  metaInfo() {
    return {
      title: this.$t('referrals.your-referrals-title'),
    };
  },
  computed: {
    ...mapRoot([ 'isRecruiter', 'isSainsburys' ]),
    ...mapRoot({
      canSyncContacts({ company }) {
        const { preferences, sitePreferences } = company || {};
        const { canSyncContacts } = { ...preferences, ...sitePreferences };
        return canSyncContacts === true;
      },
      showApplicationProgress({ company }) {
        const { preferences, sitePreferences } = company || {};
        const { hideApplicationProgress } = { ...preferences, ...sitePreferences };
        return hideApplicationProgress !== true;
      },
    }),
    lanes: () => ([
      { key: 'accepted', title: 'Referrals' },
      { key: 'inProgress', title: 'Applications' },
      { key: 'hired', title: 'Hired' },
    ]),
  },
};
</script>

<style lang="scss">
.page.referrals {
  & > .content {
    min-height: 700px;
  }

  .row.title {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .counter-icon {
    height: 2rem;
    width: 2rem;
    font-size: 1rem;
    line-height: 2rem;
  }
  .input-group-text {
    &.search-icon {
      background-color: white;
      border-right-width: 0;
      // border: 1px solid red;
    }
  }

  .lanes {
    margin-top: 2rem;

    h3 {
      font-weight: bold;
      margin-bottom: 0;
      margin-top: 0;
    }

    .lane {
      .card {
        .card-body {
          padding: 0.5rem;
          padding-left: 1rem;
          padding-right: 1rem;
          .round-icon {
            height: 50px;
            width: 50px;
            margin: 0 auto;
            margin-bottom: 1em;
            display: block;
            .svg-inline--fa {
              margin-top: 10px;
              height: 30px;
              width: 30px;
            }
          }
        }
        &.no-results {
          background: none;
          min-height: 200px;
          text-align: center;
          margin: 0 auto;
          padding: 1em;
          margin-top: 1em;
          .text {
            width: 100%;
          }
        }
      }

      $card-col-padding: 10px;

      &.single {
        > .row > .col-12 {
          padding-bottom: $card-col-padding;

          // &:nth-child(1) {
          //   padding-top: $card-col-padding;
          // }
        }
      }

      &.double {
        > .row > .col-12 {
          padding-bottom: $card-col-padding;

          &:nth-child(1), &:nth-child(2) {
            padding-top: $card-col-padding;
          }

          @media only screen and (min-width: 575px) {
            &:nth-child(odd) {
              padding-right: $card-col-padding / 2;
            }

            // &:nth-child(even) {
            //   padding-left: $card-col-padding / 2;
            // }
          }
        }
      }

      &.quadruple {
        > .row > .col-12 {
          padding-bottom: $card-col-padding;

          // &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4) {
          //   padding-top: $card-col-padding;
          // }

          @media only screen and (min-width: 575px) {
            &:nth-child(4n+1) {
              padding-right: $card-col-padding / 2;
            }
            &:nth-child(4n+2), &:nth-child(4n+3) {
              padding-right: $card-col-padding / 2;
              padding-left: $card-col-padding / 2;
            }
            &:nth-child(4n+4) {
              padding-left: $card-col-padding / 2;
            }
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/users/referrals.vue